// extracted by mini-css-extract-plugin
export default {"fieldGroup":"TypesFormFieldsGroup_fieldGroup__7I4cl"};